import React from 'react'
import { useIntl } from 'react-intl'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import CSSBreakpoint from '../../utils/CSSBreakpoint'

interface Props {
  score: number | string
  maxScore?: number
  label: string
}

function RatingBreakdownItem({ score, maxScore = 10, label }: Props) {
  const intl = useIntl()

  const maxScoreLabel = intl.formatMessage(
    {
      id: 'CC/MCKRXqZ',
      defaultMessage: '/{maxScore}',
      description: 'Maximum score denominator shown after the rating score (e.g. /10)',
    },
    { maxScore },
  )

  return (
    <>
      {/* Graph Section - Desktop */}
      <CSSBreakpoint min="tablet">
        <Group direction="vertical" gap={2}>
          <Group direction="horizontal" verticalAlign="end" gap={4}>
            <Heading variant="heading2" as="p">{score}</Heading>
            <BodyText variant="large">{maxScoreLabel}</BodyText>
          </Group>
          <BodyText variant="large">{label}</BodyText>
        </Group>
      </CSSBreakpoint>
      {/* Graph Section - Mobile */}
      <CSSBreakpoint max="mobile">
        <Group direction="vertical" gap={2}>
          <Group direction="horizontal" verticalAlign="end" gap={4}>
            <Heading variant="heading6" as="p">{score}</Heading>
            <BodyText variant="small">{maxScoreLabel}</BodyText>
          </Group>
          <BodyText variant="small">{label}</BodyText>
        </Group>
      </CSSBreakpoint>
    </>
  )
}

export default RatingBreakdownItem
